// extracted by mini-css-extract-plugin
export default {"rating":"rating__StarRating__1DxOL","filled":"filled__StarRating__1DxOL","empty":"empty__StarRating__1DxOL"};